import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ApiErrorState } from '../components/ApiErrorState.tsx';
import { TextField } from '../components/TextField.tsx';
import { INVITE_CODE_LENGTH, INVITE_CODE_PATTERN } from '../config.ts';
import { useJoinLeague } from '../features/leagues/hooks.ts';

export function JoinLeaguePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const unirse = useJoinLeague();

  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const limpio = code.trim().toUpperCase();

    if (limpio === '') {
      setError('validation.inviteCodeRequired');
      return;
    }
    if (!INVITE_CODE_PATTERN.test(limpio)) {
      setError('validation.inviteCodeFormat');
      return;
    }
    setError(null);

    const { league } = await unirse.mutateAsync(limpio);
    void navigate(`/leagues/${league.id}`, { replace: true });
  }

  return (
    <>
      <h1 className="mb-4 text-xl font-bold">{t('leagues.join.title')}</h1>

      <form onSubmit={handleSubmit} noValidate className="tarjeta" data-test="formulario-unirse">
        <ApiErrorState error={unirse.error} />

        <TextField
          label={t('leagues.join.code')}
          name="invite_code"
          value={code}
          // Se pasa a mayúsculas mientras se escribe: el backend también normaliza, pero
          // ver el código tal cual va a viajar evita la sensación de que "no lo acepta".
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          maxLength={INVITE_CODE_LENGTH}
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck={false}
          required
          className="text-center text-lg tracking-[0.3em] uppercase"
          hint={t('leagues.join.codeHint', { length: INVITE_CODE_LENGTH })}
          error={error ? t(error, { length: INVITE_CODE_LENGTH }) : undefined}
        />

        <button className="btn-primario" type="submit" disabled={unirse.isPending}>
          {unirse.isPending ? t('leagues.join.pending') : t('leagues.join.submit')}
        </button>
        <p className="mt-3 text-center text-sm">
          <Link to="/" className="text-tenue">
            {t('common.back')}
          </Link>
        </p>
      </form>
    </>
  );
}
